module.exports = __webpack_public_path__ + "img/zwy-login-logo.12579160.png";